import { FC } from "react";
import {
  ComponentSize,
  ComponentSizeClasses,
} from "../../models/tailwind/ComponentStyleProps";

type Props = {
  size?: ComponentSize;
  companyName?: string;
  src?: string;
};

const Logo: FC<Props> = ({ size, companyName, src }) => {
  const sizeClasses: ComponentSizeClasses = {
    xs: "h-6",
    sm: "h-8",
    md: "h-16",
    lg: "h-24",
    xl: "h-32",
  };

  return (
    <div className="flex shrink-0 items-center">
      <img
        className={`${size ? sizeClasses[size] : sizeClasses.md}`}
        src={src}
        alt={companyName}
      />
    </div>
  );
};

export default Logo;
